import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaTimes } from 'react-icons/fa';
import { ClaimMessages } from './ClaimMessage.style';

const getIcon = (type: 'error' | 'advice' | 'success' | 'warning' | 'info') => {
  const iconStyle = { marginRight: 0 };

  switch (type) {
    case 'advice':
    case 'info':
      return <FaInfoCircle style={{ ...iconStyle, color: '#3178c6' }} />; // azul
    case 'success':
      return <FaCheckCircle style={{ ...iconStyle, color: '#107C10' }} />; // verde
    case 'warning':
      return <FaExclamationCircle style={{ ...iconStyle, color: '#666666' }} />; // gris
    case 'error':
    default:
      return <FaExclamationCircle style={{ ...iconStyle, color: '#d92c2c' }} />; // rojo
  }
};

const ClaimMessage = ({
  type = 'error',
  message,
  onClose,
}: {
  type?: 'error' | 'advice' | 'success' | 'warning' | 'info';
  message: string;
  onClose?: () => void;
}) => {
  if (!message) return null; // ✅ No renderiza si no hay mensaje

  return (
    <ClaimMessages type={type}>
      {getIcon(type)}
      <p style={{ margin: 4 }}>{message}</p>
      {onClose && (
        <button onClick={onClose} style={{ background: 'none', border: 'none', marginLeft: 'auto' }}>
          <FaTimes />
        </button>
      )}
    </ClaimMessages>
  );
};

export default ClaimMessage;
